import imageCompression from "browser-image-compression";
import { v4 as uuid } from 'uuid';

import apiClient from "../../network/apiClient";

export const imageUploadAWS = async (files: File[]): Promise<string[]> => {
  try {
    const { data } = await apiClient.post("/vehicles/get-presigned-url", {
      files: files.map((f) => ({
        filename: generateUploadFileName(f.name),
        filetype: f.type,
      })),
    });

    await Promise.all(
      data.urls.map((u: any, i: number) =>
        fetch(u.signedUrl, {
          method: "PUT",
          headers: { "Content-Type": files[i].type },
          body: files[i],
        }),
      ),
    );

    const imageURLs = data.urls.map((u: any) => u.fileUrl);

    return imageURLs;
  } catch (error) {
    console.error("Image upload to AWS bucket error: ", error);
    throw error;
  }
};

export const compressJpg = async (file: File) => {
  const options = {
    maxSizeMB: 0.3,
    useWebWorker: true,
    initialQuality: 0.7,
    alwaysKeepResolution: true,
  };

  return await imageCompression(file, options);
};

export const getFileNameFromUrl = (url: string) => {
  return url.split("/").pop() || "image.jpg";
};

export const urlToFile = async (url: string, filename: string) => {
  const response = await fetch(url);
  const blob = await response.blob();

  return new File([blob], filename, {
    type: blob.type,
  });
};

export const generateUploadFileName = (fileName: string) => {
  const sanitizedFileName = fileName
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^\w.-]/g, "");

  return `${uuid()}-${sanitizedFileName}`;
};
